"use client"

import { parseAsInteger, parseAsStringEnum, useQueryStates } from "nuqs"
import { DropdownMenu, DropdownMenuItem, DropdownMenuTrigger } from "../DropdownMenu/dropdown-menu"
import DropdownMenuContent from "@/components/molecules/DropdownMenu/dropdown-menu-content"
import { ChevronDown } from "lucide-react"
import useLocaleStore from "@/app/stores/useLocaleStore"

export enum Sorting {
  PRICE_DESC = "minPrice:desc",
  PRICE_ASC = "minPrice:asc",
  DATE_ASC = "updatedAt:asc",
  DATE_DESC = "updatedAt:desc",
  RATING = "avgRating:desc",
}

const LABELS = {
  [Sorting.PRICE_DESC]: "Price: High to Low",
  [Sorting.PRICE_ASC]: "Price: Low to High",
  [Sorting.RATING]: "Customer Reviews",
  [Sorting.DATE_ASC]: "Newest",
  [Sorting.DATE_DESC]: "Oldest",
}

const AMH_LABELS = {
  [Sorting.PRICE_DESC]: "ዋጋ፡ ከፍ ወደ ታች",
  [Sorting.PRICE_ASC]: "ዋጋ፡ ከታች ወደ ላይ",
  [Sorting.RATING]: "የደንበኞች ግምገማዎች",
  [Sorting.DATE_ASC]: "አዲስ",
  [Sorting.DATE_DESC]: "አሮጌ",
}


interface SorterProps {
  className?: string
}

export function Sorter({ className }: SorterProps) {
  const locale = useLocaleStore((state) => state.locale)

  const [_, setQuery] = useQueryStates({
    sortBy: parseAsStringEnum<Sorting>(Object.values(Sorting)).withDefault(Sorting.RATING),
    page: parseAsInteger.withDefault(1)
  }, {
    shallow: false,
    history: "push",
  })

  return (
    <div className={className}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="flex cursor-pointer flex-wrap items-center justify-center gap-2 font-thin text-black dark:text-gray-200 [&[data-state=open]>svg]:rotate-180">
            <span>{locale === "am" ? "ዝርዝር ማስተካከያ" : "Sort by"}</span>
            <ChevronDown />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-[240px] rounded-b-md bg-white px-0 text-neutral-500 shadow-lg dark:bg-gray-800"
          align="end"
        >
          {Object.entries(locale === "am" ? AMH_LABELS : LABELS).map(([key, label]) => (
            <DropdownMenuItem
              key={label}
              className="cursor-pointer border-b border-neutral-200 py-2 last:border-b-0 hover:bg-neutral-50 focus:bg-neutral-50 active:bg-neutral-50 dark:border-gray-700 dark:bg-inherit dark:hover:bg-gray-900 dark:active:bg-gray-900"
              onClick={() => setQuery({ sortBy: key as Sorting, page: 1 })}
            >
              {label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
